module.exports = __webpack_public_path__ + "static/ftcc-f20a0de13d08f76e3a34f08527cd5757.png";